import styled from '@emotion/styled';
import KModal from '../k-modal';

export const SadaApplicatonAnswersModal = styled(KModal)``;
